// Generic Request Reducer Actions
export const FETCHING = 'FETCHING'
export const SUCCESS = 'SUCCESS'
export const ERROR = 'ERROR'
export const RESET = 'RESET'
